<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-15 11:59:53
!-->
<template>
  <div id="index" class="index">
    <div class="Steps-main">
      <Steps :active="active" :is-bj="true" />
    </div>
    <div>
      <div class="booking-title">
        <span>┃</span><span>Booking Summary</span>
      </div>
      <div class="booking-content">
        <div class="content-l">
          <div class="start-end">
            <img
              class="package-img"
              src="../../../../assets/img/client/booking/icon／价格表／飞机.png"
              width="24px"
              height="24px"
            />
            <div class="route">
              <img
                src="../../../../assets/img/client/booking/dian-icon.png"
                width="16px"
                height="16px"
              />
              <div class="line" />
              <img
                src="../../../../assets/img/client/booking/dian-icon.png"
                width="16px"
                height="16px"
              />
            </div>
            <div class="city-name">
              <span
                >{{ queryData.startCityNameEn }},{{
                  queryData.startProvinceNameEn
                }},{{ queryData.startCountryNameEn }},{{
                  queryData.startCityZipcode
                }}</span
              >
              <span
                >{{ queryData.destCityNameEn }},{{
                  queryData.destProvinceNameEn
                }},{{ queryData.destCountryNameEn }}</span
              >
            </div>
          </div>
          <div class="order-info">
            <div class="order-info-l">
              <div>EXPRESS</div>
              <div>Door to door</div>
            </div>
            <div class="order-info-r">
              <div>
                Est. transit time from pickup: {{ queryData.workDays }} days
              </div>
              <div v-if="queryData.goodsReadyType == 1">
                Goods Ready: Goods are ready
              </div>
              <div v-if="queryData.goodsReadyType == 2">
                Goods Ready: Within 2 weeks
              </div>
              <div v-if="queryData.goodsReadyType == 3">
                Goods Ready: More than 2 weeks
              </div>
            </div>
          </div>
          <div class="volume-info">
            <div class="volume-info-l">
              <div class="title">Load</div>
              <div class="load-class">
                <div class="number">{{ queryData.quantity }}</div>
                <span>✖</span>
                <div class="size">
                  <div>Boxes/Crates</div>
                  <div>Boxes</div>
                </div>
              </div>
            </div>
            <div class="volume-info-r">
              <div class="title">Total weight/volume</div>
              <div class="size">
                <div>{{ queryData.weight }} KG</div>
                <div>{{ queryData.volume }} CBM</div>
              </div>
            </div>
          </div>
          <div class="last-info">
            <div v-if="queryData.buyInsurance" class="insurance">
              <div class="title">
                Insurance: {{ queryData.insuranceInfo.insuranceName }}
              </div>
              <img
                v-if="queryData.insuranceInfo.insuranceLogo"
                :src="queryData.insuranceInfo.insuranceLogo"
                width="159px"
                height="56px"
              />
            </div>
          </div>
          <div class="tip-info">
            <img
              src="../../../../assets/img/manage/ic_warning@2x.png"
              width="16px"
              height="16px"
            />
            <span>
              This rate is valid until Nov 14, 2023. If your goods depart after
              this date, or if the actualshipment load differs from the Quote,
              the rate may be subject to an adjustment in linewith the
              marketplace rate.
            </span>
          </div>
          <div class="footer-button">
            <button class="by-button--primary" @click="clickConfirm">
              Confirm & Book Shipment
            </button>
          </div>
        </div>
        <div class="content-r">
          <div class="price-detalls-bg">
            <span>Price detalls</span>
          </div>
          <div class="price-detalls">
            <div class="detalls-item">
              <div>Quote</div>
              <div>CNY{{ queryData.subTotal1 }}</div>
            </div>
            <div class="detalls-item">
              <div>Duties and taxes</div>
              <div>Not Included</div>
            </div>
            <div
              v-if="queryData.insuranceInfo.insuranceAmount"
              class="detalls-list"
            >
              <div class="detalls-item">
                <div>Insurance</div>
                <div>CNY{{ queryData.insuranceInfo.insuranceAmount }}</div>
              </div>
              <div class="left">
                Based on value of ${{ queryData.insuranceInfo.buyAmount }}
              </div>
            </div>
            <div class="line" />
            <div class="detalls-Total">
              <div>Total</div>
              <div>CNY{{ queryData.totalAmount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="booking-before-dialog">
      <div class="booking-before">
        <div
          class="booking-before-top flex flex-column-center flex-row-between margin-top_32"
        >
          <div>
            <div class="booking-before-top-title">预订</div>
            <!-- <div class="booking-before-top-text">
            填写下面所需的信息，以便我们的提供商可以处理您的货件。
          </div> -->
          </div>
          <button type="button" class="close-btn">
            <span>关闭</span><i class="margin-left_8 el-icon-close"></i>
          </button>
        </div>
        <div class="booking-before-main ">
          <div class="booking-before-header">
            <div class="flex flex-column-center margin-top_16">
              <img
                src="../../../../assets/img/client/booking/dian-icon.png"
                width="16px"
                height="16px"
              />
              <div class="booking-before-header__line"></div>
              <img
                src="../../../../assets/img/client/booking/dian-icon.png"
                width="16px"
                height="16px"
              />
            </div>
            <div class="flex flex-column-center margin-top_16">
              <div class="flex-1 booking-before-header__text text-align-left">
                中国,广东省,深圳市｜518108
              </div>
              <img
                class="margin-left_24 margin-right_24"
                src="../../../../assets/img/client/booking/icon／价格表／飞机.png"
                width="24px"
                height="24px"
              />
              <div class="flex-1 booking-before-header__text text-align-right">
                圣克莱门特｜美国加利福尼亚州
              </div>
            </div>
          </div>
          <div class="booking-before-content flex flex-column-center">
            <div class="flex-1">
              <div class="text1">业务类型</div>
              <div class="text2 margin-top_4">快递｜门到门</div>
            </div>
            <div class="flex-1">
              <div class="text1">从提货起预计运输时间</div>
              <div class="text2 margin-top_4">6-10 天（港口到港口 1-3 天）</div>
            </div>
            <div class="flex-1">
              <div class="text1">备货时间</div>
              <div class="text2 margin-top_4">2 周内</div>
            </div>
          </div>
          <div class="booking-before-info flex flex-column-center">
            <div class="flex-1">
              <div class="text1">载量</div>
              <div class="margin-top_4 flex flex-column-center">
                <div class="number flex flex-column-center flex-row-center">
                  <span>5</span>
                </div>
                <div
                  class="number-text flex flex-column-center flex-row-center"
                >
                  X
                </div>
                <div
                  class="flex-1 number-box flex flex-column-center padding-left_16"
                >
                  <div>
                    <div class="flex flex-column-center">
                      <img
                        src="../../../../assets/img/client/booking/box@2x.png"
                        width="16px"
                        height="16px"
                      />
                      <div class="text1">盒子/板条箱</div>
                    </div>
                    <div class="text2">52 × 50 × 45 cm</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1 margin-left_24">
              <div class="text1">总重量/体积</div>
              <div
                class="margin-top_4 weight-box flex flex-column flex-column-center flex-row-center"
              >
                <div class="text1">100.00 KG</div>
                <div class="text2">0.58 CBM</div>
              </div>
            </div>
            <div class="flex-1 margin-left_24">
              <div class="text1">保险公司</div>
              <div class="margin-top_4 company-box flex flex-row-start">
                <img
                  v-if="queryData.insuranceInfo.insuranceLogo"
                  :src="queryData.insuranceInfo.insuranceLogo"
                  width="159px"
                  height="56px"
                />
              </div>
            </div>
          </div>
          <div class="booking-before-tip flex flex-column-center">
            <i class="tip-icon el-icon-warning"></i>
            <div class="margin-left_4 tip-text">
              此费率有效期至 2023 年 11 月 14
              日。如果您的货物在此日期之后出发，或者实际装运负载与报价不同，则费率可能会根据市场费率进行调整。
            </div>
          </div>
          <div
            class="booking-before-bottom flex flex-row-end flex-column-center"
          >
            <div class="total">总计：</div>
            <div class="price">CNY1,038.11</div>
            <div class="detail margin-left_8">明细</div>
            <button type="button" class="confirm-btn margin-left_24">
              <span>确认 & 预定发货</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ConfirmOrder
      v-if="isConfirmOrder"
      ref="ConfirmOrder"
      @close="
        () => {
          isConfirmOrder = false;
        }
      "
    />
  </div>
</template>

<script>
import { GetExpOrderDetail } from '@/api/order.js';
import ConfirmOrder from './confirmOrder.vue';
import Steps from '../../steps.vue';
import define from '@/utils/define';
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Steps,
    ConfirmOrder,
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      active: 3,
      isConfirmOrder: false,
      queryData: {
        insuranceInfo: {},
      },
      totalAmount: 0,
      expCompanyLogo: '',
    };
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
    isConfirmOrder: {
      handler(val) {
        if (val) {
          document.body.appendChild(this.$el);
          document.body.style.overflow = 'hidden';
        } else {
          document.body.appendChild(this.$el);
          document.body.style.overflow = 'auto';
        }
      },
    },
  },
  created() {
    // 实例被创建之后执行代码
    const orderNo = this.$route.query.orderNo;
    this.GetExpDetail(orderNo);
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    clickConfirm() {
      this.isConfirmOrder = true;
      this.$nextTick(() => {
        this.$refs.ConfirmOrder.init(this.queryData);
      });
    },
    GetExpDetail(orderNo) {
      GetExpOrderDetail(orderNo).then((res) => {
        if (res.code === 200) {
          this.queryData = res.data;
          this.expCompanyLogo = this.filterData(this.queryData.modeCodePage);
          if (this.queryData.insuranceInfo.insuranceLogo) {
            this.queryData.insuranceInfo.insuranceLogo =
              define.comUrl + this.queryData.insuranceInfo.insuranceLogo;
          } else {
            this.queryData.insuranceInfo.insuranceLogo = undefined;
          }
          this.queryData.subTotal1 = this.queryData.orderTransferFee;
          this.queryData.feeList.forEach((item) => {
            this.queryData.subTotal1 += item.totalAmount;
          });
          this.queryData.subTotal1 += this.queryData.startLiftgateAmount;
        }
      });
    },
    filterData(data) {
      switch (data) {
        case 'DHL':
          return define.comUrl + 'DHL.png';
        case 'DPD':
          return define.comUrl + 'DPD.png';
        case 'FEDEX':
          return define.comUrl + 'FEDEX.png';
        case 'UPS':
          return define.comUrl + 'UPS.png';
        case 'E-LINE':
          return define.comUrl + 'E-LINE.png';
        case 'LINE':
          return define.comUrl + 'LINE.png';
        default:
          return undefined;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.flex1 {
  display: flex;
  justify-content: space-between;
}

.font-class {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;

  div:nth-of-type(1) {
    font-weight: 600;
  }
}

.title-class {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #333333;
  height: 40px;
  text-align: left;
  line-height: 40px;
}

.index {
  margin: 0 auto;
  width: 1200px;

  .Steps-main {
    padding-top: 40px;
  }

  .booking-title {
    height: 32px;
    text-align: left;
    margin: 20px 0;

    span:nth-of-type(1) {
      color: #e95506;
      margin-right: 12px;
    }

    span:nth-of-type(2) {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }

  .booking-content {
    display: flex;

    .content-l {
      width: 894px;

      .start-end {
        width: 894px;
        height: 152px;
        background: #ffffff;
        border-radius: 8px;

        .package-img {
          margin-top: 32px;
        }

        .route {
          display: flex;
          justify-content: center;

          .line {
            width: 647px;
            height: 0px;
            border: 2px dashed rgba(2, 127, 252, 0.8);
            margin-top: 7px;
          }
        }

        .city-name {
          display: flex;
          justify-content: space-between;
          padding: 16px;

          span {
            display: inline-block;
            width: 215px;
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
        }
      }

      .order-info {
        margin: 16px 0;
        @extend .flex1;

        .order-info-l {
          width: 286px;
          height: 36px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 16px;
          padding: 26px 0;
          @extend .font-class;
        }

        .order-info-r {
          width: 592px;
          height: 88px;
          background: #ffffff;
          border-radius: 8px;
          text-align: left;

          div {
            margin: 16px;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
      }

      .volume-info {
        @extend .flex1;
        margin: 16px 0;

        .volume-info-l {
          width: 564px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }

          .load-class {
            display: flex;
            align-items: center;

            .number {
              width: 38px;
              height: 56px;
              background: rgba(233, 85, 6, 0.04);
              border-radius: 8px;
              line-height: 56px;
            }

            span {
              margin: 0 8px;
            }

            .size {
              width: 498px;
              height: 36px;
              background: rgba(233, 85, 6, 0.04);
              border-radius: 8px;
              text-align: left;
              padding: 10px 16px;
              @extend .font-class;
            }
          }
        }

        .volume-info-r {
          width: 290px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }

          .size {
            width: 258px;
            height: 36px;
            background: rgba(233, 85, 6, 0.04);
            border-radius: 8px;
            padding: 10px 0;
            @extend .font-class;
          }
        }
      }

      .last-info {
        @extend .flex1;
        margin: 16px 0;

        .carrier {
          width: 443px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }
        }

        .insurance {
          width: 443px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }
        }
      }

      .tip-info {
        margin: 8px 0px;
        display: flex;
        width: 878px;
        background: rgba(2, 127, 252, 0.04);
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #027ffc;
        padding: 8px;
        text-align: left;

        img {
          margin-right: 8px;
        }
      }

      .footer-button {
        margin: 24px 0;

        button {
          width: 400px;
          height: 40px;
        }
      }
    }

    .content-r {
      width: 282px;
      margin-left: 24px;

      .price-detalls-bg {
        width: 282px;
        height: 88px;
        background: url('../../../../assets/img/client/booking/background_color.png');
        background-size: 282px 88px;
        text-align: left;
        line-height: 47px;

        span {
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: 16px;
        }
      }

      .price-detalls {
        width: 250px;
        min-height: 188px;
        background: #ffffff;
        border-radius: 8px;
        position: relative;
        top: -40px;
        padding: 0 16px;

        .detalls-item,
        .detalls-Total {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
        }

        .detalls-item {
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .detalls-Total {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
        }

        .line {
          width: 250px;
          height: 0px;
          border: 1px dashed #dddddd;
          margin: 8px 0;
        }

        .detalls-list {
          .detalls-item {
            @extend .detalls-item;
          }

          .left {
            text-align: left;
            color: #777777;
          }
        }
      }
    }
  }
  .booking-before-dialog {
    position: fixed;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    background: rgba(0, 0, 0, 0.04);
    backdrop-filter: blur(8px);
    .booking-before {
      margin: 0 auto;
      width: 1200px;
      box-sizing: border-box;

      .booking-before-top {
        padding-bottom: 16px;
        .booking-before-top-title {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          line-height: 27px;
          text-align: left;
          font-style: normal;
        }

        .booking-before-top-text {
          margin-top: 8px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          font-size: 12px;
          color: #777777;
          line-height: 17px;
          text-align: left;
          font-style: normal;
        }

        .close-btn {
          outline: none;
          border: none;
          width: 78px;
          height: 32px;
          background: rgba(0, 0, 0, 0.08);
          border-radius: 8px;

          span {
            display: inline-block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            text-align: right;
            font-style: normal;
          }

          i {
            font-size: 14px;
            font-weight: bold;
            color: #333;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }
      .booking-before-main {
        padding: 8px;
        background: #ffffff;
        border-radius: 16px;
        .booking-before-header {
          padding: 16px 24px;
          height: 112px;
          background: #f5f7fa;
          border-radius: 10px;
          box-sizing: border-box;

          .booking-before-header__line {
            flex: 1;
            height: 1px;
            border-top: 2px dashed rgba(51, 112, 255, 0.8);
          }

          .booking-before-header__text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            font-style: normal;
          }
        }

        .booking-before-content {
          margin: 0 24px;
          min-height: 88px;
          background: rgba(255, 255, 255, 0);
          border-bottom: 1px solid #ddd;
          box-sizing: border-box;

          .text1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }

          .text2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .booking-before-info {
          margin: 0 24px;
          height: 118px;
          background: rgba(255, 255, 255, 0);
          border-bottom: 1px solid #ddd;
          box-sizing: border-box;

          .text1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }

          .number {
            width: 38px;
            height: 56px;
            background: rgba(51, 112, 255, 0.04);
            border-radius: 8px;
            box-sizing: border-box;

            span {
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #333333;
              line-height: 22px;
              text-align: center;
              font-style: normal;
            }
          }

          .number-text {
            width: 38px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            text-align: center;
            font-style: normal;
          }

          .number-box {
            height: 56px;
            background: rgba(51, 112, 255, 0.04);
            border-radius: 8px;
            .text1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 13px;
              color: #333333;
              line-height: 18px;
              text-align: left;
              font-style: normal;
            }

            .text2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #333333;
              line-height: 18px;
              text-align: left;
              font-style: normal;
            }
          }

          .weight-box {
            height: 56px;
            background: rgba(51, 112, 255, 0.04);
            border-radius: 8px;
            box-sizing: border-box;

            .text1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 13px;
              color: #333333;
              line-height: 18px;
              text-align: center;
              font-style: normal;
            }

            .text2 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #333333;
              line-height: 18px;
              text-align: center;
              font-style: normal;
            }
          }

          .company-box {
            height: 56px;
            background: rgba(51, 112, 255, 0);
            border-radius: 8px;
            box-sizing: border-box;
          }
        }

        .booking-before-tip {
          margin: 24px 24px;
          padding: 0 8px;
          min-height: 40px;
          background: rgba(2, 127, 252, 0.04);
          border-radius: 4px;
          box-sizing: border-box;

          .tip-icon {
            font-size: 16px;
            color: #3370ff;
          }

          .tip-text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #3370ff;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }
        }

        .booking-before-bottom {
          padding: 0 24px 24px 24px;
          .total {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #777777;
            line-height: 18px;
            text-align: right;
            font-style: normal;
          }

          .price-unit {
          }

          .price {
            font-family: D-DINExp, D-DINExp;
            font-weight: bold;
            font-size: 24px;
            color: #ef0a0a;
            line-height: 26px;
            text-align: right;
            font-style: normal;
          }

          .detail {
            cursor: pointer;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #3370ff;
            line-height: 18px;
            text-align: right;
            font-style: normal;
          }

          .confirm-btn {
            outline: none;
            border: none;
            width: 200px;
            height: 40px;
            background: rgb(51, 112, 255);
            border-radius: 8px;
            transition: all 0.3s;
            box-sizing: border-box;

            span {
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
            }

            &:hover {
              cursor: pointer;
              background: rgba(51, 112, 255, 0.8);
            }
          }
        }
      }
    }
  }
}
</style>
